import { Col, DatePicker, Form, Radio, Row, Select } from "antd";
import { Moment } from "moment";
import React from "react";
import { DateFormats } from "../../../../core/common/Constants";
import { TTranslate } from "../../../../core/service/locale/TranslationService";
import { CollectionTypes } from "../../../common/Constants";
const { Option } = Select;
const { RangePicker } = DatePicker;

const dateTypes = [
  {
    code: "date_dt",
    label: "Datum unosa",
    collections: null
  },
  {
    code: "decision_date_dt",
    label: "Datum disciplinske odluke",
    collections: [CollectionTypes.STAV, CollectionTypes.ODLUKA]
  }
];

const DATE_FORMAT = "DD.MM.YYYY";

export default function DateSelectionInput({
  onChange,
  translate
}: {
  translate: TTranslate;
  onChange: (dateType: string, dateRange: string) => any;
}) {
  const [selectedDateGroup, setSelectedDateGroup] =
    React.useState<string>("date");
  const [selectedDateType, setSelectedDateType] = React.useState<string>();
  const [startDate, setStartDate] = React.useState<Moment | null>();
  const [endDate, setEndDate] = React.useState<Moment | null>();
  return (
    <Row gutter={[24, 24]}>
      <Col xs={24} sm={24} md={12} xl={12} xxl={8}>
        <Form.Item
          name="dateType"
          label={translate("search.advanced.date_type")}
        >
          <Select
            allowClear
            placeholder={translate("search.advanced.date_type_placeholder")}
            className={"png-select"}
            value={selectedDateType}
            onChange={(value) => {
              setSelectedDateType(value);
              const range = `${startDate?.format(
                DateFormats.SEARCH_DATE
              )},${endDate?.endOf("day").format(DateFormats.SEARCH_DATE)}`;
              if (selectedDateType) {
                onChange(selectedDateType, range);
              }
            }}
          >
            {dateTypes?.map((item, index) => (
              <Option key={`date-type-${index}`} value={item.code}>
                {translate(`search.query.${item.code}`) || item.label}
              </Option>
            ))}
          </Select>
        </Form.Item>
      </Col>
      <Col xs={24} sm={24} md={12} xl={12} xxl={8}>
        <Radio.Group
          value={selectedDateGroup}
          onChange={(event) => setSelectedDateGroup(event.target.value)}
        >
          <Form.Item name="datum" label="">
            <Radio style={{ fontSize: "0.85em" }} value="date">
              {translate("search.advanced.date")}
            </Radio>
            <DatePicker
              disabled={selectedDateGroup === "period"}
              value={startDate}
              placeholder={translate("search.advanced.date_placeholder")}
              format={DATE_FORMAT}
              style={{ width: "100%" }}
              onChange={(value) => {
                setStartDate(value);
                setEndDate(value?.endOf("day"));
                const range = `${value?.format(DateFormats.SEARCH_DATE)},${value
                  ?.endOf("day")
                  .format(DateFormats.SEARCH_DATE)}`;
                if (selectedDateType) {
                  onChange(selectedDateType, range);
                }
              }}
            />
          </Form.Item>

          <Form.Item name="period" label="">
            <Radio style={{ fontSize: "0.85em" }} value="period">
              {translate("search.advanced.period")}
            </Radio>
            <RangePicker
              disabled={selectedDateGroup === "date"}
              format={DATE_FORMAT}
              onChange={(values) => {
                setStartDate(values?.[0]);
                setEndDate(values?.[1]);
                const range = `${values?.[0]?.format(
                  DateFormats.SEARCH_DATE
                )},${values?.[1]?.format(DateFormats.SEARCH_DATE)}`;
                if (selectedDateType) {
                  onChange(selectedDateType, range);
                }
              }}
            />
          </Form.Item>
        </Radio.Group>
      </Col>
    </Row>
  );
}
